var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "search-input"
  }, [_c('el-input', {
    directives: [{
      name: "no-emoji",
      rawName: "v-no-emoji"
    }, {
      name: "filter-special-char",
      rawName: "v-filter-special-char",
      value: {
        changeVal: _vm.changeVal,
        regular: this.regular
      },
      expression: "{changeVal,regular:this.regular}"
    }],
    attrs: {
      "placeholder": _vm.placeholder,
      "autocomplete": "off",
      "size": "small"
    },
    on: {
      "change": function ($event) {
        return _vm.search();
      }
    },
    model: {
      value: _vm.val,
      callback: function ($$v) {
        _vm.val = $$v;
      },
      expression: "val"
    }
  }), _c('i', {
    staticClass: "el-icon-search",
    on: {
      "click": function ($event) {
        return _vm.search();
      }
    }
  })], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }